
import { validationMixin } from "vuelidate";
import { mapGetters } from "vuex";
import AmbienteData, { AmbienteDataRequired } from "./AmbienteData";

export default {
  name: "app-restaurante-ambiente-form",
  props: {
    url: {
      type: String,
      required: true,
    },
    ambiente: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin],
  data() {
    return {
      tabIndex: 0,
      form: new AmbienteData({}),
    };
  },
  validations: {
    form: AmbienteDataRequired,
  },
  watch: {
    ambiente: {
      handler(newValue) {
        this.form = new AmbienteData(newValue || {});
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
  methods: {
    setAtivo() {
      this.form.ativo = this.form.ativo == true ? false : true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setSubmitLoading(isLoading) {
      const submitButton = this.$refs["submit_ambiente"];

      if (!submitButton) {
        return;
      }

      if (isLoading) {
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");
        return;
      }

      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      submitButton.removeAttribute("disabled", "");
    },
    async onSubmit() {
      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        this.setSubmitLoading(true);
        await this.$http.post(this.url, { ...this.form });
        this.$router.push({ name: "restauranteAmbientes" });
      } catch (error) {
        this.setSubmitLoading(false);
      }
    },
  },
};
